import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import global from './zh-cn/global';
import memberCenter from './zh-cn/memberCenter';
import product from './zh-cn/product';
export default _objectSpread(_objectSpread(_objectSpread({
  message: '-'
}, global), memberCenter), product);